import type { PendingInboundItem } from '@/lib/play/playCirclePendingReadService'
import type { PlayIntegratedPendingPayload } from '@/lib/play/playIntegratedTypes'

/**
 * Production GET /api/play/circle/pending returns top-level inbound/outbound.
 * Preview/nested clients may already send `{ pending: { inbound, outbound } }`.
 * Canonicalize either shape so integrated Play render never sees a partial chain.
 */
export function normalizePlayIntegratedPendingPayload(
  raw: unknown
): PlayIntegratedPendingPayload {
  const record =
    raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : {}

  const nested =
    record.pending && typeof record.pending === 'object'
      ? (record.pending as Record<string, unknown>)
      : null

  const inbound = Array.isArray(nested?.inbound)
    ? (nested.inbound as PendingInboundItem[])
    : Array.isArray(record.inbound)
      ? (record.inbound as PendingInboundItem[])
      : []

  const outbound = Array.isArray(nested?.outbound)
    ? (nested.outbound as unknown[])
    : Array.isArray(record.outbound)
      ? (record.outbound as unknown[])
      : []

  const activeDog =
    record.activeDog && typeof record.activeDog === 'object'
      ? (record.activeDog as PlayIntegratedPendingPayload['activeDog'])
      : undefined

  const actionsAvailable =
    typeof record.actionsAvailable === 'boolean'
      ? record.actionsAvailable
      : inbound.length > 0 || outbound.length > 0

  return {
    success: record.success !== false,
    ...(activeDog ? { activeDog } : {}),
    pending: { inbound, outbound },
    actionsAvailable,
  }
}
